import { Condition } from '../../../../../Questionnaires/QuestionnairesList/components/types';

const useConditionTitle = (condition?: Condition | null) => {
  return condition?.name || 'New condition';
};

export { useConditionTitle };
